import React from "react";

import { type GetCampaign_me_adObject } from "@north-beam/nb-client-side";
import { CommonTouchpointsPage } from "@pages/objects/common-touchpoints";
import { type ReportBodyState } from "@pages/sales/report-body-control";

interface CommonTouchPointsInterface {
  state: ReportBodyState;
  adObject: GetCampaign_me_adObject;
}
export const CommonTouchPoints = ({
  state,
  adObject,
}: CommonTouchPointsInterface) => {
  if (!adObject.topLevel) {
    return null;
  }
  const dateRange = {
    startDate: adObject.topLevel.startDate,
    endDate: adObject.topLevel.endDate,
  };
  return (
    <CommonTouchpointsPage
      id={adObject.id}
      dateRange={dateRange}
      state={state}
    />
  );
};
